import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faSortUp,
  faSortDown,
  faBadgeCheck,
} from "@fortawesome/pro-solid-svg-icons";
import { Formik } from "formik";
import {
  maskedBankAccountNumberNormalizer,
  OPTIONS_DATA_MAPPER,
} from "../../../utils";
import SponsorBankSavedSlider from "./SponsorBankSavedSlider";
import { AddToolTip, EnableFundingToggleSwitch } from "../../../components";

const tableHeader = [
  {
    label: "Bank Name",
    columnName: "bankAccountName",
    width: "25%",
  },
  {
    label: "Account Number",
    columnName: "bankAccountNumber",
    width: "25%",
  },
  {
    label: "Aba Routing Number",
    columnName: "abaRoutingNumber",
    width: "16.66%",
  },
  {
    label: "Account Type",
    columnName: "bankAccountType",
    width: "16.66%",
  },
  {
    label: "Status",
    columnName: "bankAccountStatus",
    width: "16.66%",
  },
];

const ACHDebit = (props) => {
  const {
    fundingId,
    planId,
    sponsorAccounts,
    planCashToggle,
    setACHToggle,
    forfeitureToggle,
    achToggle,
    setDirtyFlag,
  } = props;
  const [listValues, setListValues] = useState([]);
  const [openSlider, setOpenSlider] = useState(false);
  const [Id, setId] = useState(null);
  const [open, setOpen] = useState(false);
  const func = (id) => {
    setOpenSlider(!openSlider);
    setId(id);
  };

  return (
    <Formik
      initialValues={{
        Data: sponsorAccounts,
      }}
      enableReinitialize
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        values,
        setValues,
        errors,
        isValid,
        setFieldValue,
      }) => {
        return (
          <>
            <div className="w-100 rounded ACHDebitDetailsBox">
              <div className="accountgrid">
                <p className="p-15 fw-600 d-flex ACHDebitHeader">ACH Debit</p>

                <EnableFundingToggleSwitch
                  planId={planId}
                  modeOfFunding={"achAccountEnabled"}
                  toggle={achToggle}
                  setToggle={setACHToggle}
                  planCashToggle={planCashToggle}
                  forfeitureToggle={forfeitureToggle}
                  achToggle={achToggle}
                  id={fundingId}
                />
              </div>

              <div
                className="payroll-columns w-100"
                style={{ display: "flex", marginLeft: "10px" }}
              >
                {tableHeader.map((_, ind) => (
                  <div
                    style={{ width: _?.width }}
                    className="withdrawal-Text-Color d-flex ACHDebitAccountTableHeader ft-12"
                  >
                    {_?.label}{" "}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: "8px",
                        marginTop: "-3px",
                      }}
                    >
                      <div style={{ paddingLeft: "10px" }}>
                        <FontAwesomeIcon
                          icon={faSortUp}
                          size="xs"
                          style={{
                            cursor: "pointer",
                            marginRight: "-6px",
                            marginBottom: "3px",
                          }}
                          onClick={() => {
                            values.Data.sort((a, b) =>
                              a[_.columnName].localeCompare(b[_.columnName])
                            );
                          }}
                        />

                        <FontAwesomeIcon
                          icon={faSortDown}
                          size="xs"
                          style={{ cursor: "pointer", marginRight: "-10px" }}
                          onClick={() => {
                            values.Data.sort((b, a) =>
                              a[_.columnName].localeCompare(b[_.columnName])
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {values.Data?.map((_, ind) => {
                return (
                  <div
                    className="w-120 d-flex rounded ACHDebitCard"
                    onClick={() => func(_.id)}
                  >
                    {tableHeader.map((col, index) => {
                      return (
                        <div style={{ width: col.width }}>
                          <div
                            style={{
                              cursor: "pointer",
                              marginLeft: "10px",
                              whiteSpace: "nowrap",
                              paddingLeft: "25px",
                              paddingTop: "20px",
                              fontStyle: "normal",
                              fontWeight: "400",
                              fontSize: "16px",
                              lineHeight: "20px",
                              color: "#242426",
                            }}
                          >
                            {col.columnName === "bankAccountStatus" ? (
                              <div
                                className="activeButton"
                                style={{
                                  color:
                                    OPTIONS_DATA_MAPPER.ACCOUNT_STATUS[
                                      _[col.columnName]
                                    ] === "Active"
                                      ? "Green"
                                      : "Red",
                                  background:
                                    OPTIONS_DATA_MAPPER.ACCOUNT_STATUS[
                                      _[col.columnName]
                                    ] === "Active"
                                      ? "linear-gradient(0deg, rgba(6, 116, 26, 0.1), rgba(6, 116, 26, 0.1)), #FFFFFF"
                                      : "linear-gradient(0deg, rgba(196, 6, 26, 0.1), rgba(196, 6, 26, 0.1)), #FFFFFF",
                                }}
                              >
                                {
                                  OPTIONS_DATA_MAPPER.ACCOUNT_STATUS[
                                    _[col.columnName]
                                  ]
                                }
                              </div>
                            ) : col.columnName === "bankAccountType" ? (
                              OPTIONS_DATA_MAPPER.ACCOUNT_TYPE[
                                _[col.columnName]
                              ]
                            ) : col.columnName === "bankAccountNumber" ? (
                              maskedBankAccountNumberNormalizer(
                                _[col.columnName]
                              )
                            ) : (
                              <AddToolTip>{_[col.columnName]}</AddToolTip>
                            )}
                            {col.columnName === "bankAccountName" &&
                              _.defaultBankAccountIndicator === true && (
                                <>
                                  <FontAwesomeIcon
                                    className="primary-small"
                                    size="xs"
                                    icon={faBadgeCheck}
                                  />
                                  <span className="badgeIconText">
                                    Default Account{" "}
                                  </span>
                                </>
                              )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}

              {setOpenSlider && (
                <SponsorBankSavedSlider
                  listValues={listValues}
                  setListValues={setListValues}
                  openSlider={openSlider}
                  setOpenSlider={setOpenSlider}
                  open={open}
                  setOpen={setOpen}
                  setOuterValues={setValues}
                  outerValues={values}
                  Id={Id}
                  setId={setId}
                  fundingId={fundingId}
                  planCashToggle={planCashToggle}
                  forfeitureToggle={forfeitureToggle}
                  achToggle={achToggle}
                  setDirtyFlag={setDirtyFlag}
                />
              )}

              {/* Add Button */}
              <div className="w-120 rounded sponsorAccountCard">
                <div
                  onClick={() => {
                    setOpen(!open);
                    setId(0);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faPlus}
                    className="sponsorAccountIcon"
                    size="md"
                  />
                  <span className="sponsorAccountIconText">
                    Add New Sponsor Bank Account
                  </span>
                </div>
              </div>
            </div>
          </>
        );
      }}
    </Formik>
  );
};

export default ACHDebit;
